export default {
    parts: ['container', 'trigger', 'titleWrapper', 'chevron', 'panel'],
    baseStyle: {
        container: {
            width: '100%',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeDefault'
        },
        trigger: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            textAlign: 'left',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            p: 0
        },
        titleWrapper: {
            flex: '1'
        },
        chevron: {
            ml: 2,
            flexShrink: 0,
            transition: 'transform 0.2s ease'
        },
        panel: {}
    }
}
